import {
  AdjustmentsVerticalIcon,
  BellIcon,
  BuildingOfficeIcon,
  CodeBracketIcon,
  CreditCardIcon,
  DocumentChartBarIcon,
  PaperAirplaneIcon,
  PlayIcon,
  ShareIcon,
  TagIcon,
  UserIcon,
  UsersIcon
} from '@heroicons/react/24/solid'

// Unterseiten von /settings. Der Pfad ist zugleich der frühere Hash, so
// bleiben alte Links (/settings#plan) per Weiterleitung gültig.
export const SETTINGS_SECTIONS = [
  'personal',
  'notifications',
  'company',
  'user',
  'templates',
  'assessment',
  'talent-status',
  'resultreport',
  'dashboard',
  'plan',
  'integrations',
  'ats',
  'automations'
]

export const settingsPath = (section) => `/settings/${section}`

// Ziel für /settings mit altem Hash aus Mails, Release Notes, Assistent und
// Bookmarks. #sample-data war ein Alias für den Tab #dashboard und bleibt
// dort als Anker erhalten. Unbekannte Hashes landen beim Profil.
export const settingsPathFromHash = (hash = '') => {
  const key = hash.replace(/^#/, '')
  if (key === 'sample-data') return `${settingsPath('dashboard')}#sample-data`
  return settingsPath(SETTINGS_SECTIONS.includes(key) ? key : 'personal')
}

export const tabsConfig = (t, section) => [
  {
    id: 'PERSONAL',
    name: t('components.settings.user_profile.settings_container_title'),
    icon: UserIcon,
    current: section === 'personal',
    to: settingsPath('personal')
  },
  {
    id: 'NOTIFICATIONS',
    name: t('settings.notifications.settings_container_title'),
    icon: BellIcon,
    current: section === 'notifications',
    to: settingsPath('notifications')
  },
  {
    id: 'COMPANY',
    name: t('components.settings.company_profile.settings_container_title'),
    icon: BuildingOfficeIcon,
    current: section === 'company',
    to: settingsPath('company')
  },
  {
    id: 'USER',
    name: t('settings.user_management.settings_container_title'),
    icon: UsersIcon,
    current: section === 'user',
    to: settingsPath('user')
  },
  {
    id: 'TEMPLATES',
    name: t('settings.mail_templates.title'),
    icon: PaperAirplaneIcon,
    current: section === 'templates',
    to: settingsPath('templates'),
    badge: 'MAIL_TEMPLATES'
  },
  {
    id: 'ASSESSMENT',
    name: t('settings.assessment.title'),
    icon: AdjustmentsVerticalIcon,
    current: section === 'assessment',
    to: settingsPath('assessment')
  },
  {
    id: 'TALENT_STATUS',
    name: t('components.settings.talent_statuses.title'),
    icon: TagIcon,
    current: section === 'talent-status',
    to: settingsPath('talent-status'),
    badge: 'TALENT_STATUS'
  },
  {
    id: 'RESULTREPORT',
    name: t('components.settings.result_reports.title'),
    icon: DocumentChartBarIcon,
    current: section === 'resultreport',
    to: settingsPath('resultreport')
  },
  {
    id: 'DASHBOARD',
    name: t('components.settings.dashboard_components.title'),
    icon: AdjustmentsVerticalIcon,
    current: section === 'dashboard',
    to: settingsPath('dashboard')
  },
  {
    id: 'PLAN',
    name: t('components.settings.payment_plan.title'),
    icon: CreditCardIcon,
    current: section === 'plan',
    to: settingsPath('plan')
  },
  {
    id: 'INTEGRATIONS',
    name: t('settings.integrations.settings_container_title'),
    icon: ShareIcon,
    current: section === 'integrations',
    to: settingsPath('integrations')
  },
  {
    id: 'ATS',
    name: t('components.settings.api_keys.settings_container_title'),
    icon: CodeBracketIcon,
    current: section === 'ats',
    to: settingsPath('ats')
  },
  {
    id: 'AUTOMATIONS',
    name: t('settings.automations.tab_title'),
    icon: PlayIcon,
    current: section === 'automations',
    to: settingsPath('automations')
  }
]
